import React, { useEffect, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import { useIntl } from "react-intl";
import UserContext from "./../../context/UserContext";
import { getBalance } from "./../../api";
import "./styles.scss";

function PaymentSuccess() {
  const history = useHistory();
  const intl = useIntl();
  const userData = useContext(UserContext);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const refreshBalance = async () => {
      try {
        const response = await getBalance();
        if (response.data && response.data.saldo !== undefined) {
          userData.updateBalance(response.data.saldo * 100); // Convert to cents
        }
      } catch (error) {
        console.error("Error refreshing balance:", error);
      } finally {
        setLoading(false);
      }
    };

    // Wait 10 seconds before refreshing balance to allow payment processing to complete
    const timer = setTimeout(() => {
      refreshBalance();
    }, 10000);

    return () => clearTimeout(timer);
  }, [userData]);

  if (loading) {
    return (
      <>
        <h1>{intl.formatMessage({ id: "processando-pagamento" })}</h1>
        <div className="payment-success-page">
          <div className="notification is-info">
            <p className="loading-text">{intl.formatMessage({ id: "verificando-status-pagamento" })}</p>
            <progress className="progress is-small is-info" max="100">{intl.formatMessage({ id: "carregando" })}</progress>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <h1>{intl.formatMessage({ id: "pagamento-realizado" })}</h1>
      <div className="payment-success-page">
        <div className="notification is-success">
          <p className="success-title">
            <span className="icon">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
                <path d="M9 16.2L4.8 12L3.4 13.4L9 19L21 7L19.6 5.6L9 16.2Z" fill="currentColor"/>
              </svg>
            </span>
            {intl.formatMessage({ id: "pagamento-confirmado" })}
          </p>
          <p className="success-message">
            {intl.formatMessage({ id: "pagamento-sucesso-mensagem" })}
          </p>
          <p className="info-message">
            <strong>{intl.formatMessage({ id: "nota" })}</strong> {intl.formatMessage({ id: "pagamento-info-boleto-pix" })}
          </p>
        </div>

        <div className="buttons-container">
          <button
            className="button is-primary"
            onClick={() => history.push('/new-analysis')}
          >
            {intl.formatMessage({ id: "nova-analise" })}
          </button>

          <button
            className="button is-light"
            onClick={() => history.push('/add-funds')}
          >
            {intl.formatMessage({ id: "adicionar-fundos" })}
          </button>
        </div>
      </div>
    </>
  );
}

export default PaymentSuccess;
